import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Sheet, SheetContent, SheetTrigger, SheetHeader, SheetTitle, SheetDescription } from '../ui/sheet';
import { Menu } from 'lucide-react';

export const SiteHeader = () => {
  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4 flex h-20 items-center justify-between">
        <Link to="/" className="flex items-center">
          <img
            src="https://customer-assets.emergentagent.com/job_wellness-journeys/artifacts/amcb4t0p_Generated_image%20%281%29.png"
            alt="Therapy with Ayesha"
            className="h-14 sm:h-16 w-auto"
            data-testid="header-logo"
          />
        </Link>
        <nav className="hidden md:flex items-center space-x-6">
          <Link to="/" className="text-sm font-medium hover:text-primary">Home</Link>
          <Link to="/services" className="text-sm font-medium hover:text-primary">Services</Link>
          <Link to="/resources" className="text-sm font-medium hover:text-primary">Healing Resources</Link>
          <a href="#contact" className="text-sm font-medium hover:text-primary">Contact</a>
          <Link to="/services?service=individual">
            <Button size="sm" className="bg-primary hover:bg-primary/90">Book Session</Button>
          </Link>
        </nav>
        <Sheet>
          <SheetTrigger asChild>
            <Button variant="ghost" size="icon" className="md:hidden" data-testid="mobile-menu-trigger" aria-label="Open menu">
              <Menu className="w-6 h-6" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-72">
            <SheetHeader className="text-left">
              <SheetTitle>Menu</SheetTitle>
              <SheetDescription className="sr-only">Site navigation</SheetDescription>
            </SheetHeader>
            <nav className="flex flex-col gap-4 mt-8">
              <Link to="/" className="text-lg font-medium hover:text-primary">Home</Link>
              <Link to="/services" className="text-lg font-medium hover:text-primary">Services</Link>
              <Link to="/resources" className="text-lg font-medium hover:text-primary">Healing Resources</Link>
              <a href="#contact" className="text-lg font-medium hover:text-primary">Contact</a>
              <a href="#faq" className="text-lg font-medium hover:text-primary">FAQ</a>
              <Link to="/services?service=individual" className="mt-4">
                <Button className="bg-primary hover:bg-primary/90 w-full">Book Session</Button>
              </Link>
            </nav>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};
